import { useMedia } from "react-use";

import { Curtain } from "./Curtain";
import { TradeBoxHeaderTabs } from "./TradeBoxHeaderTabs";
import { TradeBoxV2 } from "./TradeBoxV2";

export function TradeBoxResponsiveContainer() {
  const isMobile = useMedia("(max-width: 1100px)");

  // if (!isMobile) {
    return (
      <div className="text-body-medium flex flex-col rounded-4 bg-slate-800 p-15 " data-qa="tradebox">
        <TradeBoxHeaderTabs />
        <TradeBoxV2 isMobile={isMobile} />
      </div>
    );
  // }

  // return (
  //   <Curtain header={<TradeBoxHeaderTabs isInCurtain />} dataQa="tradebox">
  //     <TradeBox isMobile={isMobile} />
  //   </Curtain>
  // );
}
